const MEMBERSHIP_HANDLES = new Set([
  "membership-standard",
  "membership-annual",
  "membership-scholar",
]);

const planCache = new Map();

function isTrueAttr(form, name) {
  const value = (form.getAttribute(name) || "").toLowerCase();
  return value === "true" || value === "1";
}

function isMembershipForm(form) {
  if (!(form instanceof HTMLFormElement)) return false;
  const handle = (form.getAttribute("data-product-handle") || "").toLowerCase();
  if (MEMBERSHIP_HANDLES.has(handle)) return true;
  return isTrueAttr(form, "data-membership-cart") || isTrueAttr(form, "data-requires-selling-plan");
}

function sellingPlanFromInput(form) {
  const input = form.querySelector('input[name="selling_plan"]');
  const value = input && String(input.value || "").trim();
  if (!value || value === "0") return "";
  return value;
}

function sellingPlanFromProductJson(product) {
  const fromGroup = product?.selling_plan_groups?.[0]?.selling_plans?.[0]?.id;
  if (fromGroup) return String(fromGroup);
  const fromAlloc = product?.variants?.[0]?.selling_plan_allocations?.[0]?.selling_plan_id;
  if (fromAlloc) return String(fromAlloc);
  return "";
}

async function fetchProductJson(handle) {
  if (!handle) return null;
  if (planCache.has(handle)) return planCache.get(handle);
  const pending = fetch(`/products/${handle}.js`, { headers: { Accept: "application/json" } })
    .then((res) => {
      if (!res.ok) throw new Error("product");
      return res.json();
    })
    .catch(() => null);
  planCache.set(handle, pending);
  return pending;
}

function ensureSellingPlanInput(form, planId) {
  let input = form.querySelector('input[name="selling_plan"]');
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = "selling_plan";
    input.autocomplete = "off";
    form.appendChild(input);
  }
  input.value = String(planId);
  return input;
}

async function resolveSellingPlanId(form) {
  const existing = sellingPlanFromInput(form);
  if (existing) return existing;
  const handle = form.getAttribute("data-product-handle") || "";
  const product = await fetchProductJson(handle);
  return sellingPlanFromProductJson(product);
}

function variantIdFromForm(form) {
  const input = form.querySelector('input[name="id"]');
  return input && String(input.value || "").trim();
}

function setCartError(form, message) {
  const el = form.querySelector("[data-cart-error]");
  if (!el) return;
  if (!message) {
    el.hidden = true;
    el.textContent = "";
    return;
  }
  el.hidden = false;
  el.textContent = message;
}

async function addMembershipToCart(form) {
  const variantId = variantIdFromForm(form);
  const sellingPlan = await resolveSellingPlanId(form);
  if (!variantId || !sellingPlan) {
    throw new Error("This membership is sold as a subscription. Refresh and try Buy again.");
  }
  ensureSellingPlanInput(form, sellingPlan);

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          selling_plan: Number(sellingPlan),
        },
      ],
    }),
  });

  if (!res.ok) {
    let description = "This membership can only be purchased with a selling plan.";
    try {
      const payload = await res.json();
      description = payload.description || payload.message || description;
    } catch (_err) {
      /* keep default */
    }
    throw new Error(description);
  }

  window.location.assign("/checkout");
}

function bindMembershipForms() {
  document.querySelectorAll("form[action*='/cart/add']").forEach((form) => {
    if (!isMembershipForm(form)) return;
    const handle = form.getAttribute("data-product-handle") || "";
    if (handle && !sellingPlanFromInput(form)) {
      fetchProductJson(handle).then((product) => {
        const planId = sellingPlanFromProductJson(product);
        if (planId) ensureSellingPlanInput(form, planId);
      });
    }
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"], button[name="add"]');
      const original = button ? button.textContent : "";
      if (button) {
        button.disabled = true;
        button.textContent = "Adding…";
      }
      setCartError(form, "");
      addMembershipToCart(form)
        .catch((err) => {
          setCartError(
            form,
            err && err.message
              ? err.message
              : "Could not add this membership. Refresh and try again."
          );
          if (button) {
            button.disabled = false;
            button.textContent = original;
          }
        });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-arzive-carousel]").forEach((root) => {
    const track = root.querySelector("[data-carousel-track]");
    if (!track) return;
    const step = () => Math.min(track.clientWidth * 0.7, 320);
    root.querySelector("[data-carousel-prev]")?.addEventListener("click", () => {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    root.querySelector("[data-carousel-next]")?.addEventListener("click", () => {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
  });
  bindMembershipForms();
});
